export const IS_FIRST_ACCESS_TO_PROFILE = 'app-membership-consume:isFirstAccessToProfile'
